import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledCrmEnrichmentJobReviewBlockWrapper = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    padding: 24px 0;

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledCrmEnrichmentJobReviewBlock = styled.div`
    width: 100%;
`;
